import React, { FC, useEffect } from 'react';
import dayjs from 'dayjs';
import Sheet from '@mui/joy/Sheet';
import CssBaseline from '@mui/joy/CssBaseline';
import StatusBadge from '../../../../../../common/StatusBadge';
import useApprovalRequestByPurchaseOrderId from '../../../../../../store/ReactQueries/procurements/approvalRequests/useApprovalRequestByPurchaseOrderId';
import { ModeTypes } from './AddPurchaseOrder';
import { useDarkModeStore } from '../../../../../../store/useDarkModeStore';
import { useLanguageStore } from '../../../../../../store/useLanguageStore';
import { getApprovalStatusInfo } from '../../../../../../enums/approvalStatus';
import { PurchaseOrderInterface } from '../../../../../../models/ProcurementModule/PurchateOrder/PurchaseOrder';

export interface ApprovalPersonsTableProps {
    mode: ModeTypes;
    form: PurchaseOrderInterface;
}

const ApprovalPersonsTable: FC<ApprovalPersonsTableProps> = ({ mode, form }) => {

    const { darkMode } = useDarkModeStore();
    const { language } = useLanguageStore();

    const purchaseOrderId = form.id && !form.id.includes('New-Purchase-Order-') ? form.id : '';
    const { data: approvalPersonsById, refetch } = useApprovalRequestByPurchaseOrderId(purchaseOrderId);

    useEffect(() => {
        refetch();
    }, [form.id]);

    return (
        <div className='w-100 d-flex justify-content-center'>
            <CssBaseline />
            <Sheet
                sx={{
                    width: '100%',
                    my: 0,
                    py: 4,
                    px: 4,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 0,
                    borderRadius: 'md',
                    boxShadow: '8px 8px 30px rgba(0, 0, 0, 0.2)',
                    background: darkMode ? 'var(--dark-mode-bg)' : 'white'
                }}
            >
                <div
                    className='mb-0 d-flex flex-row align-items-center'
                    style={{ color: darkMode ? 'white' : 'rgba(0, 0, 0, 0.6)', fontSize: 20 }}
                >
                    {language['ApprovalPersons']}
                </div>
                <div className='mt-4'>
                    <div style={{ overflowX: 'auto' }}>
                        <table className={`table ${darkMode && 'table-dark'}`}>
                            <thead>
                                <tr>
                                    <th style={{ width: '5%' }}>{language['Order']}</th>
                                    <th className='text-nowrap' style={{ width: '15%' }}>{language['Name']}</th>
                                    <th className='text-nowrap' style={{ width: '15%' }}>{language['Status']}</th>
                                    <th className='text-nowrap' style={{ width: '15%' }}>{language['Date']}</th>
                                    <th>{language['Comment']}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    approvalPersonsById?.map(item => {
                                        const statusInfo = getApprovalStatusInfo(item.status);
                                        return (
                                            <tr key={item.id}>
                                                <td className='ps-4 text-nowrap'>{item.order}</td>
                                                <td className='text-nowrap'>{item?.user?.firstname ?? ''} {item?.user?.lastname ?? ''}</td>
                                                <td className='text-nowrap'>
                                                    {
                                                        item.status
                                                            ? <StatusBadge
                                                                name={statusInfo.name}
                                                                color={statusInfo.color}
                                                                width={'fit-content'}
                                                                fontSize={12}
                                                            />
                                                            : ''
                                                    }
                                                </td>
                                                <td className='text-nowrap'>
                                                    {item.approvalDate ? dayjs(item.approvalDate).locale(language['Language'] === 'Albania' ? 'sq' : 'en').format('DD MMMM YYYY HH:mm') : ''}
                                                </td>
                                                <td title={item?.comment} className='text-nowrap'>{item?.comment?.substring(0, 50) ?? ''}</td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </Sheet>
        </div>
    );
};

export default ApprovalPersonsTable;
